import { configureStore } from "@reduxjs/toolkit";
import { citiesReduser } from "./citiesReduser/citiesReduser";
import { productReduser } from "./productsReduser/product.reduser";
import { walletsReduser } from "./walletsReduser/wallets.reduser";
import { orderReduser } from "./orders/orders.reduser";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';

import storage from 'redux-persist/lib/storage';
import { authentifitacionReduces } from "./authReduser/autentification.redusers";
import { ratesReduser } from "./rates/ratesReduser";
import { captchaReduser } from "./captchaReduser/captchaReduser";



const userConfig = {
  key: 'auth',
  storage,
  whitelist: ['token'],
};
export const store = configureStore({
  reducer: {
    citiesStore: citiesReduser,
    productsStore: productReduser,
    walletsStore: walletsReduser,
    ordersStore: orderReduser,
    ratesStore: ratesReduser,
    captchaStore: captchaReduser,
    authStore:persistReducer(userConfig, authentifitacionReduces) ,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
